import { useNavigate, useParams } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import { useEffect, useState } from 'react';
import GetHelpButton from '../../components/ScriptSure/GetHelpButton';
import ScriptSureIframeLayout from '../../components/ScriptSure/ScriptSureIframeLayout';
import {
    useGetPatientOrdersQuery,
    useUpdateOrderStatusMutation,
} from '../../features/patient/patientService';
import { OrderStatusEnum } from '../../models/PatientModels';
import { Spin } from 'antd';
import useOrderToast from '../../hooks/useOrderToast';

const PendingOrder = () => {
    const navigate = useNavigate();
    const { id: patientId = '', orderId = '' } = useParams();

    const [getHelpModalOpen, setGetHelpModalOpen] = useState<boolean>(false);
    const [scriptSureWebAppUrl, setScriptSureWebAppUrl] = useState<string>();
    const { toast } = useOrderToast();

    const { data: patientOrders, isLoading } = useGetPatientOrdersQuery({
        patientId: patientId,
        orderStatus: OrderStatusEnum.Inactive,
    });

    const order = patientOrders?.find(
        (patientOrder) => patientOrder.id === orderId,
    );

    useEffect(() => {
        if (!isLoading && !order) {
            navigate(-1);
        }
    }, [isLoading, order, navigate]);

    const [updateOrderStatus] = useUpdateOrderStatusMutation();

    const handleMessage = async (event: MessageEvent<any>) => {
        if (event.origin !== scriptSureWebAppUrl) {
            return;
        }

        const receivedMessage = event.data;
        if (receivedMessage === '200') {
            const response = await updateOrderStatus({
                orderStatus: OrderStatusEnum.Active,
                orderId: orderId ? orderId : '',
                patientId,
            });

            if (typeof response === 'object' && 'data' in response) {
                navigate(-1);
            }

            if (typeof response === 'object' && 'error' in response) {
                console.log(response.error);
                toast(
                    'The ePrescribe system successfully processed the order, but Naviscript encountered an issue during processing. The prescription is still available is ePrescribe to continue.',
                    'error',
                );
                navigate(-1);
            }
        }
    };

    useEffect(() => {
        if (scriptSureWebAppUrl)
            window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [scriptSureWebAppUrl]);

    return (
        <div>
            <PageTitle title="Pending Order" onClick={() => navigate(-1)}>
                <GetHelpButton setOpen={setGetHelpModalOpen} />
            </PageTitle>
            {!order && isLoading && <Spin spinning={isLoading} size="large" />}
            {order && (
                <ScriptSureIframeLayout
                    scriptSureSource={(
                        webAppUrl: string,
                        scriptSurePatientId: number,
                        scriptSureSessionToken: string,
                    ) =>
                        `${webAppUrl}/widgets/prescription/${scriptSurePatientId}/${order.scriptSureOrderId}?sessiontoken=${scriptSureSessionToken}&darkmode=off`
                    }
                    getHelpModalOpen={getHelpModalOpen}
                    setGetHelpModalOpen={setGetHelpModalOpen}
                    setScriptSureWebAppUrl={setScriptSureWebAppUrl}
                />
            )}
        </div>
    );
};

export default PendingOrder;
